import Resizer from 'react-image-file-resizer';

export const dataURItoBlob = (dataURI: any) => {
    const byteString = atob(dataURI.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uintArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i += 1) {
        uintArray[i] = byteString.charCodeAt(i);
    }

    return new Blob([uintArray], { type: 'image/jpeg' });
};

export const resizeFile = async (file: any) => {
    return new Promise((resolve, reject) => {
        Resizer.imageFileResizer(
            file,
            1000,
            1000,
            'JPEG',
            80,
            0,
            (uri) => {
                const resizedBlob = dataURItoBlob(uri);
                const resizeImg = new File([resizedBlob], file.name, {
                    type: 'image/jpeg',
                });
                resolve(resizeImg);
            },
            'base64',
        );
    });
};
